import { render } from "./Webhooks.vue?vue&type=template&id=173391c8&ts=true"
import script from "./Webhooks.vue?vue&type=script&lang=ts"
export * from "./Webhooks.vue?vue&type=script&lang=ts"

import "./Webhooks.vue?vue&type=style&index=0&id=173391c8&lang=css"

import exportComponent from "E:\\trackzone\\Admin_panel\\admin panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__